/*
 * @Author: Daokai Huo
 * @Date: 2021-10-19 19:28:42
 * @LastEditTime: 2021-10-19 19:38:01
 * @Description:
 */
import IonFormItem from '../form/src/ion-form-item.vue';

IonFormItem.install = function install(_vue) {
  _vue.component(IonFormItem.name, IonFormItem);
};
export default IonFormItem;
